module.exports = __webpack_public_path__ + "static/img/222_03.bef9572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/222_03.png
// module id = lvZj
// module chunks = 0